import { MEETING_DETAIL_STATUS } from '../utils/constants';
import { useGetPDCMeeting } from './useGetPDCMeeting';

const usePDCMeetingMobilityAgendaUrl = (idMeeting) => {
  const { data: meetingDetail } = useGetPDCMeeting({ idMeeting });

  const getMobilityUrl = (status) => {
    switch (status) {
      case MEETING_DETAIL_STATUS.IN_PLANNING:
        return `/pdc-meeting/${idMeeting}/mobilities`;
      case MEETING_DETAIL_STATUS.CANCELED:
      case MEETING_DETAIL_STATUS.IN_PROGRESS:
      case MEETING_DETAIL_STATUS.PUBLISHED:
        return `/pdc-meeting/${idMeeting}`;
      case MEETING_DETAIL_STATUS.IN_REVIEW:
        return `/pdc-meeting/${idMeeting}/in-review`;
      case MEETING_DETAIL_STATUS.CONCLUDED:
        return `/pdc-meeting/${idMeeting}/concluded`;
      default:
        return '/pdc';
    }
  };

  return getMobilityUrl(meetingDetail.status);
};

export default usePDCMeetingMobilityAgendaUrl;
